const eventClickCoupon = (params: any, list: string, eventLabel: string, type?: string) => {
  if (typeof window !== 'undefined' && params) {
    (window as any)?.dataLayer?.push({
      event: `productClick`,
      eventCategory: `ecommerce ${list === 'paling baru' || list === 'jual aksesoris mobil toyota' ? 'aksesoris' : list}`,
      eventLabel:
        list === 'aksesoris'
          ? `aksesoris - ${type ? type.toLowerCase() : 'not available'}`
          : eventLabel === 'jual aksesoris mobil toyota'
            ? 'jual aksesoris mobil toyota'
            : eventLabel,
      ecommerce: {
        currencyCode: 'IDR',
        click: {
          actionField: {
            list: list,
          },
          products: [params],
        },
      },
    });
  }
};
export default eventClickCoupon;
